export const DEFAULT_LOGO_SRC = '/assets/images/logos/lender_logo.svg';
export const DEFAULT_ICON_SRC = '/assets/images/logos/lender_icon.svg';
export const DEFAULT_LOGO_ALT = 'logo';
